import {Module} from "wrapper6";
import {likePost} from "../utils/_like-post";
import * as Cookies from "js-cookie"

var $ = jQuery;

export default class PostLiker extends Module {

    ready() {

        let clapper = $('#clap-icon');
        let post_id = clapper.data('post-id');

        clapper.on('click', () => {
                let is_liked = this.isInLikedCookie(post_id);

                likePost(post_id, is_liked).then((resp) => {
                    this.updateLikeCountText(resp.like_count);
                    this.toggleLikedCookie(post_id, !resp.is_liked);
                    this.toggleLikedStyle(resp.is_liked);
                })
            }
        );

    }

    /**
     * Update text in .count element
     *
     * @param like_count
     */
    updateLikeCountText(like_count) {
        $('#clap-icon').closest('.like-container')
            .find('.count')
            .text(like_count);
    }

    toggleLikedStyle(is_liked) {
        return $('#clap-icon').closest('.like-container')
            .toggleClass('liked', is_liked)
    }

    addToLikedPosts(post_id) {
        this.toggleLikedCookie(post_id, false);
    }

    removeFromLikedPosts(post_id) {
        this.toggleLikedCookie(post_id, true);
    }

    toggleLikedCookie(post_id, remove) {

        let already_liked = this.getLikedPostsFromCookie();

        if (remove === true) {
            already_liked = already_liked.filter((value) => {
                return value !== post_id
            });
        } else if (!this.isInLikedCookie(post_id)) {
            already_liked.push(post_id);
        }

        Cookies.set('liked_posts', JSON.stringify(already_liked));
    }

    isInLikedCookie(post_id) {
        let already_liked = this.getLikedPostsFromCookie();
        return already_liked.includes(post_id);
    }

    getLikedPostsFromCookie() {
        let already_liked = Cookies.get('liked_posts');

        if (typeof already_liked === "undefined") {
            already_liked = [];
        } else {
            already_liked = JSON.parse(already_liked);
        }

        return already_liked;
    }

}